module.exports = __webpack_public_path__ + "static/media/corbett.d573d334.png";